import AxiosConfig from '../../../config/AxiosConfig';

const useBlockOrRefuseRefund = () => {
  const blockOrRefuseRefund = async (
    refundId,
    profile,
    isBlocked,
    refusedDescription
  ) => {
    try {
      console.log(isBlocked ? 'block' : 'refuse');
      const response = await AxiosConfig.create('put', `/refunds/${refundId}`)
        .call({
          status: isBlocked ? 'WAITINGFI' : 'REFUSEDFI',
          actionBy: profile?._id,
          serviceName: 'finance',
          refusedDescription,
        })
        .getResponseData();

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return { blockOrRefuseRefund };
};

export default useBlockOrRefuseRefund;
